import { motion } from "framer-motion";
import { useLanguage } from "@/lib/LanguageContext";
import { paymentOptions } from "@/data/partnersData";

interface PaymentPartner {
  name: string;
  logo: string;
}

interface PaymentPartnersProps {
  options?: PaymentPartner[];
}

export default function PaymentPartners({ options = paymentOptions }: PaymentPartnersProps) {
  const { t } = useLanguage();
  
  return (
    <section className="py-16 overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold mb-4">{t('ourPaymentOptions')}</h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full"></div>
        </motion.div>

        <div className="relative w-full">
          <div className="flex overflow-hidden hover:pause">
            <div className="flex animate-marquee whitespace-nowrap">
              {[...options, ...options, ...options].map((option, index) => (
                <div
                  key={`${option.name}-${index}`}
                  className="flex items-center justify-center mx-8"
                >
                  <img
                    src={option.logo}
                    alt={option.name}
                    className="h-20 w-auto object-contain filter-none min-w-[140px] max-w-[180px] transition-all duration-300 hover:scale-110"
                    loading="lazy"
                    decoding="async"
                    style={{
                      aspectRatio: "3/2",
                      objectFit: "contain",
                      backgroundColor: "white",
                      padding: "10px",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)"
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}